<template>
  <div class="secure">
    <div class="secure__innerwrap">
      <div class="secure__row">
        <div class="secure__header">
          <h1 class="secure__title" v-html="benefit.title"></h1>
          <div class="secure__content">
            <ul>
              <li
                v-for="(item, index) in benefit.main_list"
                :key="`main-${index}`"
                v-html="item"
              ></li>
            </ul>
          </div>
        </div>
        <div class="secure__printer"><span class="secure__printer-paper"></span></div>
      </div>
      <hr class="secure__separator" />
      <div class="secure__row">
        <ul class="secure__list secure__list--1">
          <li
            v-for="(item, index) in benefit.secodary_list_1"
            :key="`sec-1-${index}`"
            v-html="item"
          ></li>
        </ul>
        <ul class="secure__list secure__list--2">
          <li
            v-for="(item, index) in benefit.secodary_list_2"
            :key="`sec-2-${index}`"
            v-html="item"
          ></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Secure',
  props: ['benefit'],
};
</script>

<style lang="scss">
@import '../../styles/helpers';

.secure {
  @include section;
  background: $c_black;
  color: $c_white;

  &__innerwrap {
    // width: 10/12 * 100%;
  }

  &__row {
    display: flex;
  }

  &__header {
    width: calc(8/12 * 100%);
    flex-shrink: 0;
  }

  &__title {
    @include font-heading;
  }

  &__content {
    @include font-content;
  }

  &__separator {
    @include separator;
  }

  &__list {
    @include unordered-list();
    @include unordered-list--dashed();

    &--1 {
      width: calc(4/12 * 100% - 25px);
      margin: 0 10px 0 15px;
    }

    &--2 {
      width: calc(6/12 * 100% - 10px);
      margin: 0 0 0 10px;
    }
  }

  &__printer {
    display: block;
    width: 199px;
    height: 127px;
    background-color: $c_black;
    background-image: url('../../assets/secure_printer-body.svg');
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    align-self: flex-end;
    z-index: 1;
    flex-shrink: 0;
    margin-bottom: -20px;

    &::after {
      content: '';
      width: 220px;
      height: 194px;
      display: block;
      position: absolute;
      z-index: -1;
      left: -145px;
      bottom: -8px;
      background-image: url('../../assets/secure_arrow.svg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
  }

  @keyframes paper-print {
    from {
      transform: translateY(100%);
    }

    50% {
      transform: translateY(100%);
    }

    to {
      transform: none;
    }
  }

  &__printer-paper {
    display: block;
    position: absolute;
    height: 54px;
    width: 127px;
    left: 36px;
    right: 36px;
    bottom: 100%;
    overflow: hidden;
    z-index: -1;

    &::before {
      content: '';
      display: block;
      background-image: url('../../assets/secure_printer-paper.svg');
      background-position: center;
      background-repeat: no-repeat;
      animation: paper-print 1.2s normal ease-out;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Secure.vue